/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Status_SuspendedInputs */

const id_profile_status_suspended = /** @type {(inputs: Profile_Status_SuspendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ditangguhkan`)
};

const en_profile_status_suspended = /** @type {(inputs: Profile_Status_SuspendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suspended`)
};

/**
* | output |
* | --- |
* | "Suspended" |
*
* @param {Profile_Status_SuspendedInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const profile_status_suspended = /** @type {((inputs?: Profile_Status_SuspendedInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Status_SuspendedInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profile_status_suspended(inputs)
	return id_profile_status_suspended(inputs)
});